// extracted by mini-css-extract-plugin
export default {"bannerContainer":"Home_bannerContainer__aNcRc"};